// `Math.scale` method
// https://rwaldron.github.io/proposal-math-extensions/
require('../internals/export')({ target: 'Math', stat: true }, { scale: require('../internals/math-scale') });
